<template>
    <nav class="navbar navbar-expand-md  fixed-top navbar-dark">
    <div class="inner">
        <a href="#" class="navbar-brand text-uppercase" >portpolio</a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarBrand">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div id="navbarBrand" >
            <ul class="navbar-nav">
                <li  v-for="(item, index) in items" :key="index" class="nav-item" ><a :href="item.id" class="nav-link text-uppercase">{{item.title}}</a></li>
            </ul>
        </div>
    </div>
    </nav>
</template>
<script>
export default {
    data () {
        return {
            items: [{id: '#webtoon', title: '연재' },
                    {id: '#comicbook', title: '만화' },
                    {id: '#events', title: '이벤트' },
                    {id: '#game', title: '게임' }]
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/NavBar.vue